import { render } from "./Educationmobile.vue?vue&type=template&id=16299dd6&scoped=true"
import script from "./Educationmobile.vue?vue&type=script&lang=js"
export * from "./Educationmobile.vue?vue&type=script&lang=js"

import "./Educationmobile.vue?vue&type=style&index=0&id=16299dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16299dd6"]])

export default __exports__